<template>
  <el-config-provider :locale="locale">
  <router-view />
  </el-config-provider>
</template>

<script setup>
import {onBeforeMount, ref} from "vue";
import { useStore } from "vuex";
import { ElConfigProvider } from 'element-plus'
import es from 'element-plus/dist/locale/es.mjs'
import 'dayjs/locale/es.js'

const store = useStore();
const locale = ref(es)
onBeforeMount(() => {
  store.dispatch("auth/initializeStore");
  });


</script>
